import type { Badge as BadgeT } from '../api/types'
import { AlertTriangle } from '@untitledui/icons'

/** PRD-018 §3.2: warning beats hot beats quiet; text alternative always present. */
export function CountBadge({ badge, quiet, label }: { badge: BadgeT, quiet: number, label: string }) {
  if (badge.kind === 'warning') {
    return (
      <span role="img" aria-label={`${label}: needs reconnect`} className="ml-auto inline-flex size-5 items-center justify-center text-[var(--shell-warning-fg)]" data-badge="warning">
        <AlertTriangle className="size-4" aria-hidden />
      </span>
    )
  }
  if (badge.kind === 'hot' && badge.count > 0) {
    return (
      <span className="ml-auto inline-flex min-w-5 items-center justify-center rounded-full px-1.5 text-xs font-semibold tabular-nums" style={{ background: 'var(--shell-hot-bg)', color: 'var(--shell-hot-fg)' }} data-badge="hot" aria-label={`${badge.count} ${badge.count === 1 ? 'item' : 'items'} waiting on you`}>
        {badge.count}
      </span>
    )
  }
  if (quiet > 0) {
    return (
      <span className="ml-auto inline-flex min-w-5 items-center justify-center rounded-full px-1.5 text-xs tabular-nums" style={{ background: 'var(--shell-quiet-bg)', color: 'var(--shell-quiet-fg)' }} data-badge="quiet" aria-label={`${quiet} open ${quiet === 1 ? 'item' : 'items'}`}>
        {quiet}
      </span>
    )
  }
  return null
}
